import { FormEvent, useContext, useEffect, useState } from 'react';
import { isFormValidated } from '../../../utils/formUtils';
import ButtonLoader from '../../common/ButtonLoader';
import { addToast } from '../../../utils/toastNotifications';
import axios from 'axios';
import { endpoints } from '../../../utils/URL';
import { Link } from 'react-router-dom';
import { VitalScreenTypes } from '../../../utils/mappings';
import { IBloodPressureData, defaultBloodPressureData } from '../../../interface/PressInterface';
import { AppContext } from '../../../context/AppContext';
import { IAppState } from '../../../interface/AppInterface';

const PressDataForm = () => {
  const [data, setData] = useState<IBloodPressureData>(defaultBloodPressureData);
  const { appState }: { appState: IAppState } = useContext(AppContext);

  const [loading, setLoading] = useState(false);

  // preview and resized file for upload
  // const [resizedFile, setResizedFile] = useState<File | undefined>();
  // const [previewUrl, setPreviewUrl] = useState<string | undefined>();

  const [preview, setPreview] = useState<string | undefined>();
  const [file, setFile] = useState<File | undefined>();
  const [screen, setScreen] = useState(VitalScreenTypes.bioData);

  const handleChange = (input: keyof IBloodPressureData) => (event: any) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

    setData({
      ...data,
      [input]: value,
    });
  };

  const deleteFile = (event: any) => {
    event?.preventDefault();
    // revoke preview URL if we created one
    // if (previewUrl) {
    //   URL.revokeObjectURL(previewUrl);
    //   setPreviewUrl(undefined);
    // }
    // setResizedFile(undefined);
    setData({ ...data, fileUrl: '' });
    setFile(undefined);
  };

  // useEffect(() => {
  //   // cleanup preview URL when component unmounts
  //   return () => {
  //     if (previewUrl) URL.revokeObjectURL(previewUrl);
  //   };
  // }, [previewUrl]);

  // // Read EXIF orientation from JPEG file (returns 1-8, or 1 if not found)
  // const getImageOrientation = (file: File): Promise<number> => {
  //   return new Promise((resolve) => {
  //     const reader = new FileReader();
  //     reader.onload = function (e) {
  //       const view = new DataView((e.target as any).result as ArrayBuffer);
  //       if (view.getUint16(0, false) !== 0xffd8) {
  //         // not a jpeg
  //         resolve(1);
  //         return;
  //       }
  //       let offset = 2;
  //       const length = view.byteLength;
  //       while (offset < length) {
  //         const marker = view.getUint16(offset, false);
  //         offset += 2;
  //         if (marker === 0xffe1) {
  //           // APP1 marker detected, parse EXIF
  //           offset += 2;
  //           const exifHeader = offset;
  //           // check for 'Exif' header
  //           if (view.getUint32(exifHeader, false) !== 0x45786966 /* 'Exif' */) {
  //             break;
  //           }
  //           const little = view.getUint16(exifHeader + 6, false) === 0x4949;
  //           const tiffOffset = exifHeader + 10;
  //           const firstIFDOffset = tiffOffset + view.getUint32(exifHeader + 14, little);
  //           const entries = view.getUint16(firstIFDOffset, little);
  //           for (let i = 0; i < entries; i++) {
  //             const entryOffset = firstIFDOffset + 2 + i * 12;
  //             const tag = view.getUint16(entryOffset, little);
  //             if (tag === 0x0112) {
  //               const value = view.getUint16(entryOffset + 8, little);
  //               resolve(value);
  //               return;
  //             }
  //           }
  //           break;
  //         } else if ((marker & 0xff00) !== 0xff00) {
  //           break;
  //         } else {
  //           offset += view.getUint16(offset, false);
  //         }
  //       }
  //       resolve(1);
  //     };
  //     reader.onerror = () => resolve(1);
  //     // read first 64KB should be enough
  //     const slice = file.slice(0, 64 * 1024);
  //     reader.readAsArrayBuffer(slice);
  //   });
  // };

  // const resizeImageFile = (
  //   file: File,
  //   maxWidth = 800,
  //   maxHeight = 800,
  //   quality = 0.75
  // ): Promise<File> => {
  //   return new Promise((resolve, reject) => {
  //     (async () => {
  //       try {
  //         const orientation = await getImageOrientation(file);
  //         const image = new Image();
  //         const url = URL.createObjectURL(file);
  //         image.onload = () => {
  //           let width = image.width;
  //           let height = image.height;
  //           let targetWidth = width;
  //           let targetHeight = height;

  //           // calculate new dimensions while preserving aspect ratio
  //           if (width > maxWidth || height > maxHeight) {
  //             const widthRatio = maxWidth / width;
  //             const heightRatio = maxHeight / height;
  //             const ratio = Math.min(widthRatio, heightRatio);
  //             targetWidth = Math.round(width * ratio);
  //             targetHeight = Math.round(height * ratio);
  //           }

  //           // swap dimensions for rotations 90/270
  //           const needSwap = [5, 6, 7, 8].includes(orientation);
  //           const canvas = document.createElement('canvas');
  //           canvas.width = needSwap ? targetHeight : targetWidth;
  //           canvas.height = needSwap ? targetWidth : targetHeight;
  //           const ctx = canvas.getContext('2d');
  //           if (!ctx) {
  //             URL.revokeObjectURL(url);
  //             reject(new Error('Could not get canvas context'));
  //             return;
  //           }

  //           // apply transforms according to EXIF orientation
  //           switch (orientation) {
  //             case 2: // horizontal flip
  //               ctx.translate(canvas.width, 0);
  //               ctx.scale(-1, 1);
  //               break;
  //             case 3: // 180°
  //               ctx.translate(canvas.width, canvas.height);
  //               ctx.rotate(Math.PI);
  //               break;
  //             case 4: // vertical flip
  //               ctx.translate(0, canvas.height);
  //               ctx.scale(1, -1);
  //               break;
  //             case 5: // vertical flip + 90 rotate
  //               ctx.rotate(0.5 * Math.PI);
  //               ctx.scale(1, -1);
  //               break;
  //             case 6: // 90° rotate
  //               ctx.rotate(0.5 * Math.PI);
  //               ctx.translate(0, -canvas.height);
  //               break;
  //             case 7: // horizontal flip + 90 rotate
  //               ctx.rotate(0.5 * Math.PI);
  //               ctx.translate(canvas.width, -canvas.height);
  //               ctx.scale(-1, 1);
  //               break;
  //             case 8: // -90° rotate
  //               ctx.rotate(-0.5 * Math.PI);
  //               ctx.translate(-canvas.width, 0);
  //               break;
  //             default:
  //               break;
  //           }

  //           // draw image into canvas with scaling
  //           // when orientation causes swap, draw with swapped target dims
  //           if (needSwap) {
  //             ctx.drawImage(
  //               image,
  //               0,
  //               0,
  //               targetWidth,
  //               targetHeight,
  //               0,
  //               0,
  //               canvas.width,
  //               canvas.height
  //             );
  //           } else {
  //             ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  //           }

  //           canvas.toBlob(
  //             (blob) => {
  //               URL.revokeObjectURL(url);
  //               if (!blob) {
  //                 reject(new Error('Canvas is empty'));
  //                 return;
  //               }
  //               const resized = new File([blob], file.name, { type: blob.type });
  //               resolve(resized);
  //             },
  //             file.type || 'image/jpeg',
  //             quality
  //           );
  //         };
  //         image.onerror = (err) => {
  //           URL.revokeObjectURL(url);
  //           reject(err);
  //         };
  //         image.src = url;
  //       } catch (err) {
  //         reject(err);
  //       }
  //     })();
  //   });
  // };

  // const onCameraInputChange = async (e: any) => {
  //   const f = e.target.files && e.target.files[0];
  //   if (!f) return;

  //   try {
  //     // resize the file (defaults: max 800x800, quality 0.75)
  //     const resized = await resizeImageFile(f);

  //     // create preview URL and set states
  //     const objectUrl = URL.createObjectURL(resized);
  //     // revoke previous preview if any
  //     if (previewUrl) URL.revokeObjectURL(previewUrl);
  //     setPreviewUrl(objectUrl);
  //     setResizedFile(resized);
  //     setData({ ...data, fileUrl: objectUrl });
  //   } catch (err) {
  //     console.error('Error resizing image', err);
  //     // fallback to original file preview
  //     const fallback = URL.createObjectURL(f);
  //     if (previewUrl) URL.revokeObjectURL(previewUrl);
  //     setPreviewUrl(fallback);
  //     setResizedFile(f);
  //     setData({ ...data, fileUrl: fallback });
  //   }
  // };

  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files && e.target.files[0];
    if (f) {
      setFile(f);
    }
  };

  const previousBtn = (event: any) => {
    event.preventDefault();
    setScreen(VitalScreenTypes.bioData);
  };

  const uploadFileAsync = async (): Promise<string> => {
    if (!file) {
      return '';
    }
    const formData = new FormData();
    formData.append('formFile', file);
    //  formData.append('formFile', uploadedFile);
    formData.append('pharmacyCode', appState.pharmacyCode || '');

    const url = `${endpoints.compliance.mainUrl}/files`;

    try {
      const response = await axios.post(url, formData);
      const fileUrl: string = response.data;
      return fileUrl;
    } catch (error) {
      addToast('Error uploading file', 'error');
      return '';
    }
  };

  const submitData = async (event: FormEvent) => {
    if (!isFormValidated('press-biodata-form')) {
      return;
    }

    event.preventDefault();
    setLoading(true);
    const fileUrl = await uploadFileAsync();

    if (fileUrl === '') {
      addToast('File upload failed', 'error');
      setLoading(false);
      return;
    }

    let payload = data;
    payload.fileUrl = fileUrl;
    const url = `${endpoints.press.mainUrl}`;

    try {
      setLoading(true);

      await axios.post(url, payload);
      addToast('Form submitted successfully', 'success');
      setData(defaultBloodPressureData);
      setScreen(VitalScreenTypes.feedback);
      setFile(undefined);
    } catch (error) {
      addToast('An error occurred when saving the data. Please try again', 'error');
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!file) {
      setPreview(undefined);
      return;
    }
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);

    // cleanup when component unmounts or file changes
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return (
    <section className='pt-0 row justify-content-center'>
      {screen === VitalScreenTypes.bioData && (
        <section className='mt-5 col-xl-5 col-lg-7 col-md-8 col-sm-10 content-section pb-5 mb-5 card'>
          <div className='text-center'>
            {/* <img
              src={require('../../../assets/images/vitals/logo.svg').default}
              className='img-fluid w-25'
              alt=''
            /> */}
            {/* Press Data Form */}
          </div>
          <div>
            <h3 className='text-center mt-4 fw-500'>
              {/* Add a back button here */}
              <Link to='/press' className='float-start btn btn-outline-primary btn-sm'>
                <span className='bi bi-arrow-left'></span> Back
              </Link>
              Engagement Log
            </h3>
            <div className='row justify-content-center content-section mt-1'>
              <div className='rounded-2'>
                <form id='press-biodata-form'>
                  <fieldset disabled={loading}>
                    {/* BIO DATA */}

                    <div className='form-group'>
                      <label className='form-label'>Full name of Patient</label>
                      <input
                        className='form-control vital-form-control'
                        value={data.fullName}
                        required
                        onChange={handleChange('fullName')}
                      />
                    </div>

                    <div className='form-group mt-4'>
                      <label className='form-label'>Phone Number of Patient</label>
                      <input
                        className='form-control  vital-form-control'
                        value={data.phoneNumber}
                        required
                        onChange={handleChange('phoneNumber')}
                        pattern='[0-9]{10}|[0]{1}[7-9]{1}[0-2]{1}[0-9]{8}|[2]{1}[3]{1}[4]{1}[0-9]{10}'
                      />
                    </div>

                    <div className='form-group mt-4'>
                      <label className='d-block'>Gender</label>

                      <div className='form-check mt-2 form-check-inline'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='gender'
                          id='female-gender'
                          checked={data.gender === 'Female'}
                          onChange={handleChange('gender')}
                          value={'Female'}
                        />
                        <label className='form-check-label' htmlFor='female-gender'>
                          Female
                        </label>
                      </div>
                      <div className='form-check mt-2 form-check-inline'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='gender'
                          id='male-gender'
                          checked={data.gender === 'Male'}
                          onChange={handleChange('gender')}
                          value={'Male'}
                        />
                        <label className='form-check-label' htmlFor='male-gender'>
                          Male
                        </label>
                      </div>
                    </div>

                    <div className='form-group mt-4'>
                      <label className='form-label'>Age range</label>
                      <select
                        className='form-select'
                        value={data.ageRange}
                        onChange={handleChange('ageRange')}
                        required
                      >
                        <option value=''>Select age range</option>
                        <option value='18-25'>18-25</option>
                        <option value='26-35'>26-35</option>
                        <option value='36-45'>36-45</option>
                        <option value='46-55'>46-55</option>
                        <option value='56+'>56 and above</option>
                      </select>
                    </div>

                    <div className='form-group mt-4'>
                      <label className='form-label' htmlFor='has-bp'>
                        Have you ever had High Blood Pressure
                      </label>

                      <div className='form-check mt-2  ms-2 form-check-inline'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          onChange={handleChange('hasHistoryOfHBP')}
                          value={data.hasHistoryOfHBP ? 'true' : 'false'}
                          id='has-bp'
                        />
                        <label className='form-check-label' htmlFor='female-gender'></label>
                      </div>
                    </div>

                    <hr />
                    <div className='row'>
                      <div className='form-group col-md-4 mt-4'>
                        <label className='form-label'>Systolic</label>
                        <input
                          type='number'
                          step={1}
                          min={10}
                          max={200}
                          className='form-control'
                          required
                          value={data.systolic}
                          onChange={handleChange('systolic')}
                        />
                      </div>
                      <div className='form-group col-md-4 mt-4'>
                        <label className='form-label'>Diastolic</label>
                        <input
                          type='number'
                          step={1}
                          min={10}
                          max={200}
                          className='form-control'
                          required
                          value={data.diastolic}
                          onChange={handleChange('diastolic')}
                        />
                      </div>
                      <div className='form-group col-md-4 mt-4'>
                        <label className='form-label'>Heart Rate</label>
                        <input
                          type='number'
                          step={1}
                          min={10}
                          max={200}
                          className='form-control'
                          required
                          value={data.heartRate}
                          onChange={handleChange('heartRate')}
                        />
                      </div>
                    </div>

                    {/* Camera input */}
                    {!preview && (
                      <label
                        htmlFor='camera-input'
                        className='mt-5 pointer d-block form-group mt-4 text-center border border-2 border-primary rounded-2 p-4'
                      >
                        <label className='form-label d-block'>Capture Photo of Reading</label>
                        <input
                          type='file'
                          accept='image/*'
                          capture='environment'
                          id='camera-input'
                          onChange={onFileChange}
                          style={{ display: 'none' }}
                        />
                        <label
                          htmlFor='camera-input'
                          style={{ cursor: 'pointer', display: 'inline-block' }}
                        >
                          <i className='bi bi-camera fs-48 text-primary'></i>
                        </label>
                      </label>
                    )}
                    {preview && (
                      <div className='mt-4'>
                        <label className='form-label d-block'>Uploaded Image</label>
                        <div className='d-flex col-md-12 justify-content-center'>
                          <img
                            src={preview}
                            alt='signature'
                            className='img-fluid'
                            // data-has-resized={resizedFile ? '1' : '0'}
                            // style={{ maxWidth: '100%', height: 'auto' }}
                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                            // height={48}
                            // width={48}
                          />
                        </div>
                        <div className='d-flex mt-2 justify-content-center'>
                          <button
                            className='btn btn-danger btn-sm col-md-4'
                            title='delete'
                            onClick={deleteFile}
                          >
                            <span className='float-end bi bi-trash fs-16'></span>
                            Replace Image
                          </button>
                        </div>
                      </div>
                    )}

                    {/* <div className='form-group mt-4 text-center border border-2 border-primary rounded-2 p-4'>
                          <label className='form-label d-block'>Capture Photo</label>
                          <input
                            type='file'
                            accept='image/*'
                            capture='environment'
                            id='camera-input'
                            style={{ display: 'none' }}
                          />
                          <label
                            htmlFor='camera-input'
                            style={{ cursor: 'pointer', display: 'inline-block' }}
                          >
                            <i className='bi bi-camera fs-48 text-primary'></i>
                          </label>
                        </div> */}

                    {/* <div className='form-group mt-4'>
                          <label className='form-label'>Additional Notes</label>
                          <textarea
                            className='form-control'
                            rows={5}
                            value={data.additionalNotes}
                            onChange={handleChange('additionalNotes')}
                          ></textarea>
                        </div> */}
                    <div className='mt-4 row justify-content-end'>
                      {/* <div className='col-sm-6 d-grid mt-3'>
                        <Link
                          to={'/press'}
                          type='button'
                          className='btn btn-outline-secondary vitals-bg-white fs-18 fw-500 vitals-text-primary vitals-border-primary px-0'
                        >
                          <span className='bi bi-house me-2'></span>
                          Back Home
                        </Link>
                      </div> */}
                      <div className='col-sm-12 d-grid mt-3'>
                        <button
                          type='submit'
                          onClick={submitData}
                          className='btn btn-secondary text-white vitals-bg-primary fs-18 fw-500 px-4'
                        >
                          Submit
                          {loading && <ButtonLoader />}
                        </button>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
      {screen === VitalScreenTypes.feedback && (
        <section className='pt-5 content-section pb-5 mb-5 card'>
          <div className='text-center'>
            {/* <img
              src={require('../../../assets/images/vitals/logo.svg').default}
              className='img-fluid w-10'
              alt=''
            /> */}
          </div>
          <div className='mt-5 text-center pb-200'>
            <img
              src={require('../../../assets/images/vitals/clap.svg').default}
              className='img-fluid'
              alt=''
            />
            <div className='fs-40 fw-700'>Great Job</div>
            <div className='fs-20 fw-400'>you are helping to make Nigerians healthier</div>
            <div className='mt-3 fs-20 fw-400'>Are you willing to fill another form?</div>
            <div className='mt-4 row justify-content-center'>
              <div className='col-md-4'>
                <div className='row justify-content-center'>
                  <div className='col-5 d-grid mt-3'>
                    <button
                      onClick={previousBtn}
                      className='btn btn-secondary text-white vitals-bg-primary fs-18 fw-500 px-4'
                    >
                      Yes
                    </button>
                  </div>
                  <div className='col-5 d-grid mt-3'>
                    <Link
                      to={'/press'}
                      type='button'
                      className='btn btn-outline-secondary vitals-bg-white fs-18 fw-500 vitals-text-primary vitals-border-primary px-5'
                    >
                      No
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </section>
  );
};

export default PressDataForm;
